import { ChevronUp, Send, Star } from "lucide-react";

/* Realistic mobile attendee interface, code-built inside a phone frame. */
export default function PhoneMockup({ className = "" }) {
  const questions = [
    { text: "How do you handle regulation across markets?", votes: 27, anon: true },
    { text: "Biggest hiring challenge for early teams?", votes: 19, anon: false },
    { text: "Local partnership vs building solo?", votes: 14, anon: true },
  ];
  return (
    <div className={`relative mx-auto w-[280px] ${className}`}>
      <div className="rounded-[2.2rem] border-[8px] border-primary bg-primary shadow-xl">
        <div className="rounded-[1.6rem] overflow-hidden bg-background">
          {/* status bar */}
          <div className="h-6 bg-primary flex items-center justify-center">
            <div className="h-1.5 w-16 rounded-full bg-white/30" />
          </div>

          {/* session header */}
          <div className="px-4 pt-4 pb-3 border-b border-border">
            <p className="text-[10px] uppercase tracking-[0.16em] text-accent font-bold">Live session</p>
            <h4 className="font-display font-bold text-foreground text-sm leading-tight mt-0.5">
              Fintech Beyond Payments
            </h4>
            <p className="text-[11px] text-muted-foreground mt-0.5">Kwame Mensah</p>
          </div>

          {/* questions */}
          <div className="p-3 space-y-2 bg-muted/30">
            {questions.map((q, i) => (
              <div key={i} className="rounded-lg bg-card border border-border p-2.5 flex items-start gap-2.5">
                <button className="flex flex-col items-center rounded-md border border-border px-1.5 py-1 text-[10px] text-foreground">
                  <ChevronUp className="h-3.5 w-3.5 text-accent" />
                  <span className="font-bold">{q.votes}</span>
                </button>
                <div className="flex-1">
                  <p className="text-[11px] text-foreground leading-snug">{q.text}</p>
                  <p className="text-[9px] text-muted-foreground mt-1">{q.anon ? "Anonymous" : "Attendee"}</p>
                </div>
              </div>
            ))}

            {/* rate */}
            <div className="rounded-lg bg-card border border-border p-2.5">
              <p className="text-[10px] text-muted-foreground mb-1.5">Rate this session</p>
              <div className="flex gap-1">
                {[1, 2, 3, 4, 5].map((s) => (
                  <Star key={s} className={`h-4 w-4 ${s <= 4 ? "fill-accent text-accent" : "text-border"}`} />
                ))}
              </div>
            </div>
          </div>

          {/* ask bar */}
          <div className="p-3 border-t border-border flex items-center gap-2">
            <div className="flex-1 h-8 rounded-full border border-border bg-muted/40 px-3 flex items-center text-[10px] text-muted-foreground">
              Ask a question…
            </div>
            <button className="h-8 w-8 rounded-full bg-accent flex items-center justify-center">
              <Send className="h-3.5 w-3.5 text-white" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
